module.exports = __webpack_public_path__ + "img/2.d4a6504.jpg";